<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-06-20 10:46:18
-->
<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:size="width"
		:before-close="handleClose"
		custom-class="drawer-template"
	>
		<div>
			<!-- 弹窗内容部分 -->
			<el-table :data="list" class="table-small" v-loading="loading">
				<el-table-column label="时间" prop="addTime">
					<template slot-scope="{ row }">
						<span class="yx-color-text-primary">{{ row.addTime }}</span>
					</template>
				</el-table-column>
				<el-table-column label="类型" prop="actionType">
					<template slot-scope="{ row }">
						<span class="yx-color-text-primary">{{ row.actionType }}</span>
					</template>
				</el-table-column>
				<el-table-column label="描述" prop="remark">
					<template slot-scope="{ row }">
						<span class="yx-color-text-primary">{{ row.remark }}</span>
					</template>
				</el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="page.page_index"
				:page-size="page.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			></yx-pagination>
		</div>
		<div class="drawer-footer yx-background-white">
			<el-button @click="handleClose">我知道了</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { productCommonLog } from '@/api/secondColonelManage';
export default {
	props: {},
	data() {
		return {
			title: '推广动态', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			page: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			loading: false, // 表格加载状态
			id: '',
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(id) {
			this.id = id;
			this.visible = true;
			this.getListData();
		},
		// 获取表格列表数据
		async getListData() {
			// 列表loading状态开启
			this.loading = true;
			const { id } = this;
			try {
				const { list = [], total = '0' } = await productCommonLog({ id });
				this.list = list;
				this.total = `${total}`;
			} catch (error) {
				this.list = [];
				this.total = 0;
			} finally {
				// 列表loading状态关闭
				this.loading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.id = '';
			this.page = {
				page_index: 1,
				page_size: 20,
			};
			this.loading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.page.page_size = val;
			this.page.page_index = 1;
			this.getListData();
		},
		// 页数变化
		currentChange(val) {
			this.page.page_index = val;
			this.getListData();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 抽屉尺寸，small:500px，normal:800px，large:1080px
			this.size = 'default';
			// 表单标签长度
			this.labelWidth = '100px';
		},
	},
	components: {},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.table-small {
	::v-deep thead th {
		font-weight: 600 !important;
	}
}
</style>